import styled, { css } from 'styled-components';
import { animated } from 'react-spring';

interface ContainerProps {
  type?: 'success' | 'error' | 'info' | 'warning';
  hasdescription: number;
}

const toastTypeVariations = {
  info: css`
    background: var(--info);
    color: var(--white);
  `,
  warning: css`
    background: var(--warning);
    color: var(--black);
  `,
  success: css`
    background: var(--success-2);
    color: var(--white);
  `,
  error: css`
    background: var(--error);
    color: var(--white);
  `,
};

export const Container = styled(animated.div)<ContainerProps>`
  width: 22rem;
  z-index: 12;

  position: relative;
  padding: 1rem 2rem 1rem 1rem;
  border-radius: 0.5rem;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);

  display: flex;

  & + div {
    margin-top: 0.5rem;
  }

  ${(props) => toastTypeVariations[props.type || 'info']}

  > svg {
    margin: 0.25rem 0.75rem 0 0;
    stroke: var(--white);
  }

  div {
    flex: 1;

    p {
      margin-top: 0.25rem;
      font-size: 1rem;
      opacity: 0.8;
      line-height: 20px;
    }

    h4 {
      ${(props) => toastTypeVariations[props.type || 'info']}
    }
  }

  ${(props) =>
    !props.hasdescription &&
    css`
      align-items: center;

      svg {
        margin-top: 0;
      }
    `}
`;
